/* eslint-disable no-undef */
import React from "react";
import PropTypes from "prop-types";

import * as types from "../../constants/ComponentConstants";

import Section from "../common/Section";
import Form from "../common/Form";

const BovenLokaliteitPerDossierForm = (props) => {
	const {
		bovenLokaliteitPerDossier,
		infrastructuren,
		validationMessageType
	} = props;

	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={types.COLOR_PURPLE}>
			<Form
				title="Bovenlokaliteit van de sportinfrastructuren"
				name="bovenLokaliteit"
				validationMessage="Er werd nog geen gemeente en/of infrastructuur ingegeven voor dit project"
				validationMessageType={validationMessageType} />
		</Section>
	);
};

// ----------------------------------------------------------------------------
BovenLokaliteitPerDossierForm.propTypes = {
	bovenLokaliteitPerDossier: PropTypes.object,
	infrastructuren: PropTypes.array,
	validationMessageType: PropTypes.string
};

export default BovenLokaliteitPerDossierForm;
